import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.scss";

import Homepage from "./pages/Homepage";
import SupportPage from "./pages/SupportPage";
import OfferPage from "./pages/OfferPage";
import LoginPage from "./pages/LoginPage";
import ErrorPage from "./pages/ErrorPage";

import Navbar from "./Components/Navbar";

export default class App extends Component {
  render() {
    return (
      <Router>
        <main>
          <Navbar />
          <Switch>
            <Route exact path="/" component={Homepage} />
            <Route path="/support" component={SupportPage} />
            <Route path="/offer" component={OfferPage} />
            <Route path="/login" component={LoginPage} />
            <Route component={ErrorPage} />
          </Switch>
        </main>
      </Router>
    );
  }
}
